import { FC } from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { FormProps } from "@dashboard/modules/products/types/product-form.types";
import { ProductType } from "@dashboard/modules/products/types/products.types";
import { resetFieldsOnTypeChange } from "@dashboard/modules/products/utils/service-form.utils";
import { ProductTypeTabsWrapper } from "./product-type-tabs.styled";

type ProductTypeTabsProps = {
  onTypeChange: (type: ProductType) => void;
};

const ProductTypeTabs: FC<ProductTypeTabsProps> = ({ onTypeChange }) => {
  const { t } = useTranslation();
  const { productId } = useParams();
  const { values, setValues } = useFormikContext<FormProps>();

  if (productId !== "new") {
    return null;
  }

  const handleTabChange = (type: ProductType) => {
    if (values.type === type) {
      return;
    }
    onTypeChange(type);
    setValues({
      ...values,
      ...resetFieldsOnTypeChange(type),
    });
  };

  return (
    <ProductTypeTabsWrapper>
      <button
        type="button"
        className={`product-type-tab ${
          values.type !== ProductType.Service ? "active" : ""
        }`}
        onClick={() => handleTabChange(ProductType.Product)}
      >
        {t("productComponent.service.tabs.product")}
      </button>
      <button
        type="button"
        className={`product-type-tab ${
          values.type === ProductType.Service ? "active" : ""
        }`}
        onClick={() => handleTabChange(ProductType.Service)}
      >
        {t("productComponent.service.tabs.service")}
      </button>
    </ProductTypeTabsWrapper>
  );
};

export default ProductTypeTabs;
